import { createContext } from 'react';
const MenuContext = createContext({
    inlineCollapsed: false,
});
export default MenuContext;
